<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Open Space Technology</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="titlepage">
<a id="pagei">
<h1>OPEN SPACE <br/><span class="small">TECHNOLOGY </span></h1>
</a></div><a id="pagei">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HalfTitlePage.vue?0980c40a